<template>
  <v-select hide-details="auto" :label="label" v-bind="$attrs" :dense="dense" v-on="$listeners" :items="companies"
    :item-text="itemText" :item-value="itemValue" >
    <template v-slot:selection="{ item, index, items }">
      <template v-if="index < 3">
        <v-chip class="ma-1" small>
          {{ item.name }}
        </v-chip>
      </template>

      <template v-if="index === 3">
        <span class="grey--text text-caption ml-2">

          (+{{ $attrs.value.length - 3 }} outros)
        </span>
      </template>
    </template>
  </v-select>

</template>

<script>

export default {
  props: {
    itemText: {
      default() {
        return (val) => val.name;
      },
    },

    itemValue: {
      default() {
        return (val) => val;
      },
    },

    dense: {
      default: true,
    },
  },

  computed: {
    companies() {
      let companies = this.$store.state.company.companies;

      if (this.$attrs.exclude) {
        companies = companies.filter(
          (row) => row.id !== this.$attrs.exclude.id
        );
      }

      if (this.$attrs.filter) {
        companies = companies.filter((row) => this.$attrs.filter(row));
      }

      return companies;
    },
    label() {
      return this.$attrs.label ? this.$attrs.label : "Empresa";
    },
  },
};
</script>

<style></style>








<!-- <template>
  <app-select
    :label="label"
    v-bind="$attrs"
    :dense="dense"
    v-on="$listeners"
    :items="companies"
    :item-text="itemText"
    :item-value="itemValue"
  />
</template>

<script>
export default {
  props: {
    itemText: {
      default() {
        return (val) => val.name;
      },
    },

    itemValue: {
      default() {
        return (val) => val;
      },
    },

    dense: {
      default: true,
    },
  },

  computed: {
    companies() {
      let companies = this.$store.state.company.companies;

      if (this.$attrs.exclude) {
        companies = companies.filter(
          (row) => row.id !== this.$attrs.exclude.id
        );
      }

      if (this.$attrs.filter) {
        companies = companies.filter((row) => this.$attrs.filter(row));
      }

      return companies;
    },
    label() {
      return this.$attrs.label ? this.$attrs.label : "Empresa";
    },
  },
};
</script>

<style>
</style> -->